import { darkTheme } from '../../../lib/tokens';
export const colors = darkTheme.colors;
export const channelLabel = (channel: string) =>
  ({ YOUTUBE: 'YouTube', INSTAGRAM: 'Instagram', FACEBOOK: 'Facebook', APP: 'App', TIKTOK: 'TikTok' })[
    channel
  ] ?? channel;
export const field = 'min-h-[44px] w-full rounded-md border border-white/20 bg-transparent px-3 py-2 text-sm';
export const button =
  'min-h-[44px] rounded-md border border-white/20 px-3 py-2 text-sm font-semibold disabled:opacity-40';
export const fixedStates = ['SUBMITTING', 'PROCESSING', 'UNKNOWN', 'LIVE', 'SIMULATED', 'REMOVED'];
export const stateNames: Record<string, string> = {
  REMOVED: 'Entfernt',
  DRAFT: 'Entwurf',
  PREPARING: 'Wird vorbereitet',
  ARMED: 'Automatisch eingeplant',
  SUBMITTING: 'Wird übergeben',
  PROCESSING: 'Wird verarbeitet',
  UNKNOWN: 'Ausgang unklar',
  LIVE: 'Veröffentlicht',
  HALTED: 'Angehalten',
  CANCELLED: 'Abgebrochen',
  FAILED: 'Nicht veröffentlicht',
  SIMULATED: 'Test abgeschlossen',
};
export function plusDays(date: string, n: number): string {
  return new Date(new Date(`${date}T12:00:00Z`).getTime() + n * 86400000).toISOString().slice(0, 10);
}
export function monday(date: string): string {
  return plusDays(date, -((new Date(`${date}T12:00:00Z`).getUTCDay() + 6) % 7));
}
export function today(): string {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}
export const dayLabel = (date: string) =>
  new Intl.DateTimeFormat('de-DE', {
    timeZone: 'UTC',
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
  }).format(new Date(`${date}T12:00:00Z`));
